import type { Platform } from "../platform/types.js";

export type AssetBank = {
  images: Map<string, CanvasImageSource>;
};

const CANDIDATES = [
  "bg.jpg",
  "bg.png",
  "icon.png",
  "char-scholar.png",
  "char-xia.png",
  "char-scholar-cut.png",
  "char-xia-cut.png",
] as const;

/** 从 assets/ 读图；缺失则返回空 Map，渲染层走程序化绘制。 */
export async function loadAssets(platform: Platform): Promise<AssetBank> {
  const images = new Map<string, CanvasImageSource>();
  const jobs = CANDIDATES.map(async (name) => {
    const img = await platform.loadImage(`assets/${name}`);
    if (img) images.set(name.replace(/\.(png|jpe?g|webp)$/i, ""), img);
  });
  await Promise.all(jobs);
  return { images };
}

export function img(bank: AssetBank, name: string): CanvasImageSource | null {
  return bank.images.get(name) ?? null;
}
